import _styled from "styled-components";
import { useTranslation } from "react-i18next";
import Icon from "../../Styled/Icon";
import IconWrapper from "../../Styled/IconWrapper";
import { jsx as _jsx } from "react/jsx-runtime";
export default function PrivateIndicator(props) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(_StyledIconWrapper, {
    marginRight: !props.inWorkbench,
    title: t("catalogItem.privateIndicatorTitle"),
    children: /*#__PURE__*/_jsx(Icon, {
      glyph: Icon.GLYPHS.lock
    })
  });
}
var _StyledIconWrapper = _styled(IconWrapper).withConfig({
  displayName: "PrivateIndicator___StyledIconWrapper",
  componentId: "sc-10ycfao-0"
})(["margin-top:-1px;svg{width:15px;height:15px;fill:", ";}"], p => p.inWorkbench ? p.theme.textLight : p.theme.charcoalGrey);